export default __webpack_public_path__ + "static/media/drive-mate-long-blue.088404f7.png";